module.exports = __webpack_public_path__ + "img/yzh8.bd715178.jpg";